/* Mediheal card quick-add: option picker (EComposer PDPs have no product-info) */
(function () {
  if (window.__mhCardQuickAdd) return;
  window.__mhCardQuickAdd = true;

  var css =
    '#mh-opt-root[hidden]{display:none!important}' +
    '#mh-opt-root{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px}' +
    '.mh-opt-backdrop{position:absolute;inset:0;background:rgba(15,15,20,.45)}' +
    '.mh-opt-sheet{position:relative;width:min(420px,100%);background:#fff;color:#111;border-radius:12px;padding:22px 20px 18px;box-shadow:0 16px 50px rgba(0,0,0,.22)}' +
    '.mh-opt-kicker{margin:0 0 6px;font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#666}' +
    '.mh-opt-title{margin:0 0 16px;font-size:16px;font-weight:600;line-height:1.35}' +
    '.mh-opt-list{display:flex;flex-direction:column;gap:8px}' +
    '.mh-opt-list button{appearance:none;width:100%;padding:12px 14px;border:1px solid #111;background:#fff;color:#111;font-size:14px;font-weight:600;cursor:pointer;border-radius:4px}' +
    '.mh-opt-list button:hover{background:#111;color:#fff}' +
    '.mh-opt-close{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;background:transparent;font-size:22px;line-height:1;cursor:pointer;color:#111}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var CART_HIT = '.quick-add, .quick-add__submit, modal-opener, product-form';
  var picker = null;

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function optionsFromCard(card) {
    return Array.prototype.map.call(card.querySelectorAll('.card-var-btn'), function (btn) {
      return {
        id: btn.getAttribute('data-variant-id'),
        title: (btn.textContent || '').replace(/\s+/g, ' ').trim(),
        available: btn.getAttribute('data-available') !== 'false',
        btn: btn
      };
    }).filter(function (opt) { return !!opt.id; });
  }

  function ensurePicker() {
    if (picker) return picker;
    picker = document.createElement('div');
    picker.id = 'mh-opt-root';
    picker.hidden = true;
    picker.innerHTML =
      '<div class="mh-opt-backdrop" data-mh-opt-dismiss></div>' +
      '<div class="mh-opt-sheet" role="dialog" aria-modal="true" aria-labelledby="mh-opt-title">' +
        '<button type="button" class="mh-opt-close" data-mh-opt-dismiss aria-label="Close">×</button>' +
        '<p class="mh-opt-kicker">Select an option</p>' +
        '<p class="mh-opt-title" id="mh-opt-title"></p>' +
        '<div class="mh-opt-list"></div>' +
      '</div>';
    document.body.appendChild(picker);
    picker.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-mh-opt-dismiss')) picker.hidden = true;
    });
    return picker;
  }

  function showPicker(card, submit) {
    var opts = optionsFromCard(card);
    if (!opts.length) return false;
    ensurePicker();
    var titleEl = card.querySelector('.card__heading, .prgrid-name-style, a.full-unstyled-link');
    picker.querySelector('#mh-opt-title').textContent = titleEl
      ? titleEl.textContent.replace(/\s+/g, ' ').trim()
      : 'Select an option';
    var list = picker.querySelector('.mh-opt-list');
    list.innerHTML = '';
    opts.forEach(function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = opt.available ? opt.title : opt.title + ' — Sold out';
      b.disabled = !opt.available;
      b.addEventListener('click', function () {
        card.querySelectorAll('.card-var-btn').forEach(function (x) {
          x.classList.toggle('active', x === opt.btn);
        });
        picker.hidden = true;
        addVariant(opt.id, submit);
      });
      list.appendChild(b);
    });
    picker.hidden = false;
    return true;
  }

  function rebindCardNav(root) {
    (root || document).querySelectorAll('.card__inner[onclick]').forEach(function (inner) {
      if (inner.getAttribute('data-mh-nav') === '1') return;
      inner.setAttribute('data-mh-nav', '1');
      var raw = inner.getAttribute('onclick') || '';
      inner.removeAttribute('onclick');
      var match = raw.match(/location\.href\s*=\s*['"]([^'"]+)['"]/);
      var href = match ? match[1] : '';
      inner.addEventListener('click', function (e) {
        if (closest(e.target, CART_HIT + ', a, button, input, label, .card-var-btn')) return;
        if (href) window.location.href = href;
      });
    });
  }

  function addVariant(variantId, button) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var spinner = button && button.querySelector('.loading__spinner');
    if (button) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
    }
    if (spinner) spinner.classList.remove('hidden');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          window.alert(response.description || response.message || 'Could not add to cart');
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response
          });
        }
        // SlideCart HQ is the side cart on this store: refresh and open it instead of the theme notification/drawer.
        if (document.getElementById('slidecarthq') && typeof window.SLIDECART_UPDATE === 'function' && typeof window.SLIDECART_OPEN === 'function') {
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (fullCart) {
              window.SLIDECART_UPDATE(fullCart);
              window.SLIDECART_OPEN();
            })
            .catch(function (err) { console.error(err); });
        } else if (typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        if (button) {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var submit = closest(e.target, '.quick-add__submit');
      if (!submit) return;
      var card = closest(submit, '.card-wrapper, .product-card-wrapper');
      if (!card) return;

      var active = card.querySelector('.card-var-btn.active[data-variant-id]') ||
        (!card.querySelector('.card-var-btn') && card.querySelector('.mh-card-default-variant[data-variant-id]'));
      var opts = optionsFromCard(card);
      if (!active && !opts.length) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (active) {
        addVariant(active.getAttribute('data-variant-id'), submit);
        return;
      }
      showPicker(card, submit);
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && picker) picker.hidden = true;
  });

  function boot() { rebindCardNav(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { rebindCardNav(e.target); });
})();
